<template>
  <b-row>
    <b-col md="12">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <div class="row mb-5">
           <div class="col-md-6">
              <fg-input label="Total Point">
                <p class="badge bg-info text-white">{{model.count_point}}</p>
              </fg-input>
              <fg-input label="Nama">
                <p>{{model.name}}</p>
              </fg-input>
              <fg-input label="Kateori Pelanggan">
                <p>{{model.category}}</p>
              </fg-input>
              <fg-input label="Email">
                <p>{{model.email}}</p>
              </fg-input>
              <fg-input label="Telelpon">
                <p>{{model.phone}}</p>
              </fg-input>
              <fg-input label="Alamat">
                <p>{{model.address}}</p>
              </fg-input>
              <fg-input label="Tanggal Dibuat">
                <p>{{model.createdAt}}</p>
              </fg-input>
              <fg-input label="Dibuat Oleh">
                <p>{{model.created_by != '' ? model.created_by.name : '-'}} ({{model.created_by != '' ? model.created_by.roles[0].name : '-'}})</p>
              </fg-input>
              <fg-input label="Diperbarui Oleh">
                <p>{{model.last_updated_by != '' ? model.last_updated_by.name : '-'}} ({{model.last_updated_by != '' ? model.last_updated_by.roles[0].name : '-'}})</p>
              </fg-input>
           </div>
        </div>
        <edit-button/>
        <back-button/>
      </card>
    </b-col>
  </b-row>
</template>

<script>
  import {Switch} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'

  export default {
    components: {
      LProgress,
      EditButton: Edit,
      BackButton: Back,
      LSwitch: Switch
    },
    data () {
      return {
        isLoading: false,
        apiUrl: {
          customer: window.AppConfig.apiUrl + 'customer'
        },
        model: {
          category: '',
          created_by: null,
          last_updated_by: null,
          name: '',
          email: '',
          phone: '',
          createdAt: ''
        }
      }
    },
    watch: {
      '$route.params.uuid': function (val) {
        this.getDetail()
      }
    },
    mounted () {
      this.getDetail()
    },
    methods: {
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.customer + '/' + this.$route.params.id)
        .then(response => {
          this.model.category = response.data.customer_category.name
          this.model.created_by = response.data.created_by
          this.model.last_updated_by = response.data.last_updated_by
          this.model.name = response.data.name
          this.model.count_point = response.data.count_point
          this.model.email = response.data.email
          this.model.phone = response.data.phone
          this.model.address = response.data.address
          this.model.createdAt = response.data.created_at
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      changeSwitch (prop, label, value) {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-warning mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            let data = {}
            data[prop] = value
            data['uuid'] = this.$route.params.uuid
            this.$http.put(window.AppConfig.apiUrl + 'customer' + '/' + this.$route.params.id, data)
            .then(response => {
              this.$store.dispatch('notification/success', label + ' Successfully updated.')
            })
            .catch(error => {
              this.$store.dispatch('notification/error', error)
              this.model[prop] = value ? 0 : 1
            })
          } else {
            this.model[prop] = value ? 0 : 1
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Customers/Show.vue